import React from 'react'
import injectSheet from 'react-jss'
import styles from './edit-title-dialog.styles'
import Button from 'pobble-components/dist/button'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import TextArea from 'pobble-components/dist/form-elements/form-text-area'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import { Formik } from 'formik'
import * as Yup from 'yup'
import FormSelect from 'pobble-components/dist/form-elements/form-select'

const EditTitleDialog = ({
  classes,
  id,
  onUpdate,
  isOpen,
  onClose,
  title,
  description,
  moderation_type,
  judgement
}) => (
  <Modal isOpen={isOpen}>
    <ModalHeader>Edit your moderation file</ModalHeader>
    <Formik
      initialValues={{
        editedTitle: title,
        editedDescription: description,
        editedModerationType: moderation_type,
        editedJudgement: judgement
      }}
      validationSchema={Yup.object().shape({
        editedTitle: Yup.string().required('The title should not be empty'),
        editedDescription: Yup.string().required(
          'The description should not be empty'
        )
      })}
      onSubmit={({
        editedTitle,
        editedDescription,
        editedModerationType,
        editedJudgement
      }) =>
        onUpdate({
          title: editedTitle,
          context: editedDescription,
          moderation_type: editedModerationType,
          judgement: editedJudgement
        }) && onClose()
      }>
      {props => {
        const { handleSubmit, handleChange, values, errors, isValid } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy>
              <p>
                <FormLabel htmlFor="afTitle">Title:</FormLabel>
                <FormInput
                  id="afTitle"
                  validationError={errors.editedTitle}
                  name="editedTitle"
                  value={values.editedTitle}
                  onChange={handleChange}
                />
              </p>
              <p>
                <FormLabel htmlFor="afDesc">Description:</FormLabel>
                <TextArea
                  id="afDesc"
                  validationError={errors.editedDescription}
                  name="editedDescription"
                  value={values.editedDescription}
                  onChange={handleChange}
                />
              </p>
              <p>
                <FormLabel
                  htmlFor={'editedModerationType'}
                  className={classes.label}>
                  Type <small className={classes.optional}>(optional)</small>
                </FormLabel>
                <FormSelect
                  value={values.editedModerationType}
                  onChange={handleChange}
                  name="editedModerationType">
                  <option value={''} default>
                    Not applicable
                  </option>
                  <option value={'in_school_moderation'}>
                    In school moderation
                  </option>
                  <option value={'cross_school_moderation'}>
                    Cross school moderation
                  </option>
                  <option value={'statutory_moderation'}>
                    Statutory moderation
                  </option>
                  <option value={'external_non_statutory_moderation'}>
                    External non statutory moderation
                  </option>
                </FormSelect>
              </p>
              <p>
                <FormLabel
                  htmlFor={'editedJudgement'}
                  className={classes.label}>
                  Judgement
                  <small className={classes.optional}>(optional)</small>
                </FormLabel>
                <FormSelect
                  value={values.editedJudgement}
                  onChange={handleChange}
                  name="editedJudgement">
                  <option value={''} default>
                    Not applicable
                  </option>
                  <option value={'working_towards_the_expected_standard'}>
                    Working towards the expected standard (WTS)
                  </option>
                  <option value={'working_at_the_expected_standard'}>
                    Working at the expected standard (EXS)
                  </option>
                  <option value={'greater_depth_within_the_expected_standard'}>
                    Greater depth within the expected standard (GDS)
                  </option>
                  <option value={'eyfs_emerging'}>EYFS Emerging</option>
                  <option value={'eyfs_expected'}>EYFS Expected</option>
                </FormSelect>
              </p>
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button simple action={onClose}>
                Cancel
              </Button>
              <Button type="submit" disabled={!isValid}>
                Edit
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(EditTitleDialog)
